<template>
  <div class="modal fade !p-0" id="cancelClaimModal" ref="cModal" tabindex="-1" aria-labelledby="cancelClaimModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered tablet:w-[450px]">
      <div class="modal-content !rounded-[10px] border-0 shadow-lg font-poppins">
        <div class="modal-body !p-[10px]">
          <div class="relative h-[80px] bg-customBlue-100 rounded-[10px]">
            <button type="button" @click="hide"
              class="absolute top-3 right-4 z-50 focus:!outline-none focus:!shadow-none bg-transparent border-0"
              aria-label="Close">
              <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon" class="w-[30px] h-[30px]">
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <div class="relative flex justify-between items-center w-full z-10 ps-6 !pe-12">
                <h6 class="m-0 text-[20px] font-poppins font-semibold text-white tracking-wider">
                  Update Visit Date & Time
                </h6>
              </div>
            </div>
          </div>
          <div class="p-[20px] min-h-[150px]">
            <p class="text-[#666666] mb-[10px] text-[16px] font-poppins font-normal">Please Select Date & Time:</p>

            <date-picker v-model:value="selectedDate"
              input-class="!text-[16px] !font-poppins disable-input !rounded-[10px] focus:!outline-none !border-[#ccc] cursor-pointer"
              type="datetime" format="MM/DD/YYYY hh:mm A" :placeholder="'Select Date'" :confirm="true"
              :disabled-date="disabledBefore" :disabled-time="disabledBeforeTime" :readonly="false"
              :append-to-body="false" :append-to="'.preferredDateTimePg'" :clearable="false" :editable="false"
              value-type="format" class="focus:!border-[#ccc]" :time-title-format="'MM/DD/YYYY'">
              <template #icon-calendar>
                <img src="../../assets/images/create-claim-calendar-icon.svg" alt="calendar"
                  class="w-5 h-5 cursor-pointer" />
              </template>
            </date-picker>

            <p v-if="false" class="text-[#666666] my-[10px] text-[16px] font-poppins font-normal">Please select end time slot:</p>
            <singleSelectDropdown v-if="false" :options="options" optionKey="title" selectValueKey="value" fieldName="slot"
              :updateOption="updateSlot" :selectedOptions="selectedSlot" placeholder="Select Reason" class="mb-0"
              inputClass="p-2.5 px-[10px] rounded-[5px] w-full border text-left border-customGray focus:outline-none text-[16px] font-poppins" />
            <div class="mt-[20px] flex flex-row justify-center gap-3">
              <button @click="hide"
                class="hidden w-auto px-6 py-2 rounded-full text-[16px] font-normal transition-all CustomYellowBtn !border-[1px] !bg-transparent !text-customYellow-100 laptop:hover:!text-black-100">
                Dismiss
              </button>
              <button @click="handleSubmit"
                class="CustomYellowBtn w-auto px-6 py-2 rounded-full text-[16px] font-normal transition-all disabled:bg-[#EFEFEF] disabled:hover:bg-gradient-to-r disabled:hover:from-[#EFEFEF] disabled:hover:to-[#EFEFEF] disabled:hover:!text-[#999999] disabled:cursor-not-allowed disabled:!text-[#999999] disabled:!border-[#EFEFEF] "
                :disabled="!selectedSlot || !selectedDate">
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import singleSelectDropdown from '../partialComponent/singleSelectDropdown.vue';
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import { Modal } from 'bootstrap';
import DatePicker from "vue-datepicker-next";
import moment from "moment";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  name: 'resheduleApptModal',
  components: {
    DatePicker,
    singleSelectDropdown
  },
  data() {
    return {
      modal: null,
      id: null,
      selectedDate: null,
      selectedSlot: 4,
      options: [
        {
          title: '2',
          value: '2'
        }, {
          title: '4',
          value: '4'
        },
      ]
    };
  },

  watch: {
    claimResheduleResponse : function (data) {
      this.$emit('cancelled');
      this.hide();
    },

  },
  computed: {
    ...mapGetters(['claimResheduleResponse']),
  },
  methods: {
    ...mapActions(['claimReshedule']),

    disabledBefore: function (date) {
      const cdate = new Date();
      cdate.setHours(0, 0, 0, 0);
      return date < cdate;
    },

    disabledBeforeTime: function (date) {
      const hours = date.getHours()
      const minutes = date.getMinutes()

      if (hours < 6) {
        return true
      }

      if (hours > 20 || (hours === 20 && minutes > 0)) {
        return true
      }

      return false
    },

    handleDateChange(newDate) {
      // if (newDate) {
      //   let data = moment(newDate).unix();
      //   this.selectedDate = data;
      // } else {
      //   this.unixTime = null;
      // }
    },

    updateSlot(field, value) {
      this.selectedSlot = value
    },

    async show(id, dateTime) {
      this.id = id;
      this.selectedDate = dateTime != "-" ? this.$helper.formatDateTime(dateTime) : null
      this.selectedSlot = 4

      // Initialize and show modal
      if (!this.modal) {
        this.modal = new Modal(this.$refs.cModal);
      }
      this.modal.show();
      disableScroll();
    },

    hide() {
      if (this.modal) {
        this.modal.hide();
      }
      enableScroll();
    },

    async handleSubmit() {
      const selectedDateTime = moment(this.selectedDate, "MM/DD/YYYY hh:mm A");
      const now = moment();

      // Check if selected time is in the past
      if (selectedDateTime.isBefore(now)) {
        toast.error("You cannot select a past date and time.");
        return;
      }

      // Check if selected time is within 6:00 AM to 8:00 PM
      const hours = selectedDateTime.hours();
      const minutes = selectedDateTime.minutes();

      if (hours < 6 || hours > 20 || (hours == 20 && minutes > 0)) {
        toast.error("Please select a time between 6:00 AM and 8:00 PM.");
        return;
      }


      this.claimReshedule({
        "claimID": this.id,
        "start_date": selectedDateTime.utc().unix(),
        "end_visit_date_time": this.selectedSlot
      })
    }
  }
};
</script>
